import { inject, Injectable, signal } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { environment } from '@env/environment';

export interface Country {
  name: {
    common: string; // اسم الدولة بالعادي
    official: string;
  };
  cca2: string; // كود ISO 2 (مثلاً EG, US)
  flags: {
    svg: string;
    png: string;
  };
}
export interface ReviewApi {
  id: number;
  quality_of_work_rating: number;
  communication_rating: number;
  on_time_delivery_rating: number;
  overall_rating: number;
  comment: string;
  freelancer_reply: string | null;
}
export interface PaginatedResponse {
  message: string;
  status: boolean;
  data: ReviewApi[];
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}
export interface CitiesResponse {
  error: boolean;
  msg: string;
  data: string[]; // Array of city names
}

export interface City {
  id: number | string;
  name: string;
  state?: string; // اختياري لو فيه States
  countryCode?: string; // عشان نربطه بالدولة
}

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  perPage = signal<number>(9);
  page = signal<number>(1);

  isOpened = signal({
    type: '',
    status: false,
    title: null,
    values: null,
  });
  refreshComponent = signal(false);
  previewMode = signal<boolean>(false);
  refreshData = signal<any>({});
  profileType = signal<string>('');
  constructor(private http: HttpClient) {}

  setPreviewMode(status: boolean) {
    this.previewMode.set(status);
  }

  setProfileType(type: string) {
    this.profileType.set(type);
    this.isOpened().type = type;
  }

  changeEditStatus(obj: any) {
    this.isOpened.set(obj);
  }

  refreshDataObj(obj: any) {
    this.refreshData.set(obj);
  }
  // settings
  validation(form: any) {
    const formData = new FormData();
    if (form.official_document) {
      formData.append('official_document', form.official_document);
    }
    if (form?.professional_document) {
      formData.append('professional_document', form.professional_document);
    }
    return this.http.post(`${environment.endpoint}/validations`, formData);
  }

  getProfile(username: string) {
    return this.http.get(`${environment.endpoint}/profile/${username}`);
  }
  getReviews(username: string, page: any = 1, per_page: number = 10) {
    return this.http.get<PaginatedResponse>(
      `${environment.endpoint}/profile/${username}/reviews?page=${page}&per_page=${per_page}`
    );
  }
  sendProfile(form: any) {
    const formData = new FormData();

    Object.keys(form).forEach((key) => {
      const value = form[key];
      if (value === null || value === undefined) {
        return;
      }
      if (value instanceof File) {
        // لو File مباشرة
        formData.append(key, value);
      } else if (Array.isArray(value)) {
        if (key === 'languages' && value.length === 0) {
          // ✅ خاص بـ languages فقط
          formData.append(`${key}[]`, '');
        } else {
          value.forEach((item, i) => {
            if (typeof item === 'object' && item !== null) {
              // array of objects
              Object.keys(item).forEach((innerKey) => {
                formData.append(`${key}[${i}][${innerKey}]`, item[innerKey]);
              });
            } else {
              // array عادية
              formData.append(`${key}[${i}]`, item);
            }
          });
        }
      } else if (typeof value === 'object' && value !== null) {
        // single object (غير File)
        Object.keys(value).forEach((innerKey) => {
          formData.append(`${key}[${innerKey}]`, value[innerKey]);
        });
      } else {
        // string, number, boolean
        formData.append(key, value);
      }
    });

    return this.http.post(`${environment.endpoint}/auth/profile`, formData);
  }

  getSkills() {
    return this.http.get(`${environment.endpoint}/skills`);
  }

  getCountries() {
    return this.http.get<Country[]>(`${environment.endpoint}/countries`);
  }

  getCitiesByCountry(countryId: string) {
    console.log(countryId);

    return this.http.get<CitiesResponse>(`${environment.endpoint}/countries/${countryId}/cities`);
  }

  getCategories() {
    return this.http.get(`${environment.endpoint}/categories`);
  }
  getFreelancerCategories() {
    return this.http.get(`${environment.endpoint}/freelancers/categories`);
  }

  getCategory(id: any) {
    return this.http.get(`${environment.endpoint}/categories/child/${id}`);
  }
  getBudgets() {
    return this.http.get(`${environment.endpoint}/budgets`);
  }
  getLanguages() {
    return this.http.get(`${environment.endpoint}/languages`);
  }

  getPortfolios(userName?: string, page: any = 1, per_page: number = 10, status: string = '') {
    return this.http.get(
      `${environment.endpoint}/profile/${userName}/portfolios?page=${page}&per_page=${per_page}${
        status ? `&status=${status}` : ''
      }`
    );
  }

  // getPortfolios(type:string){
  //   return this.http.get(`${environment.endpoint}/${type}s/portfolios`);
  // }

  getPortfolio(id: any, isOwner?: boolean) {
    return this.http.get(`${environment.endpoint}/portfolios/${id}`);
  }

  addPortfolio(form: any) {
    const Form = new FormData();
    if (form.cover_photo instanceof File) {
      Form.append('cover_photo', form.cover_photo);
    }
    Object.keys(form).forEach((key) => {
      if (form[key] != '' && form[key] != null && form[key] != undefined) {
        const value = form[key];
        if (key == 'attachments' && form[key]?.length > 0) {
          for (let i = 0; i < value.length; i++) {
            Form.append(`attachment_ids[${i}]`, value[i]);
          }
        }

        if (key == 'tags' && Array.isArray(value)) {
          for (let i = 0; i < value.length; i++) {
            Form.append(`tags[${i}]`, value[i]);
          }
        }

        if (key != 'attachments' && key != 'tags') {
          Form.append(key, value);
        }
      }
    });
    return this.http.post(`${environment.endpoint}/freelancers/portfolios`, Form);
  }

  editPortfolio(form: any, id: any) {
    const Form = new FormData();
    Form.append('_method', 'PATCH');
    if (form.cover_photo instanceof File) {
      Form.append('cover_photo', form.cover_photo);
    }

    if (form.cover_photo == null) {
      Form.append('cover_photo', 'null');
    }
    Object.keys(form).forEach((key) => {
      if (form[key] != '' && form[key] != null && form[key] != undefined && key != 'cover_photo') {
        const value = form[key];
        if (key == 'attachments' && form[key]?.length > 0) {
          for (let i = 0; i < value.length; i++) {
            Form.append(`attachment_ids[${i}]`, value[i]);
          }
        }

        if (key == 'tags' && Array.isArray(value)) {
          for (let i = 0; i < value.length; i++) {
            Form.append(`tags[${i}]`, value[i]);
          }
        }

        if (key != 'attachments' && key != 'tags') {
          Form.append(key, value);
        }
      }
    });
    return this.http.post(`${environment.endpoint}/freelancers/portfolios/${id}`, Form);
  }

  deletePortfolio(id: any) {
    return this.http.delete(`${environment.endpoint}/freelancers/portfolios/${id}`);
  }

  upload(form: any, type: any) {
    const Form = new FormData();
    Form.append('file', form.file);
    Form.append('type', type || 'portfolio');
    return this.http.post(`${environment.endpoint}/upload`, Form);
  }

  // hashtatgs
  getHashtags(search: any) {
    return this.http.get(`${environment.endpoint}/hashtags?search=${search}`);
  }

  // services
  addService(form: any) {
    const Form = new FormData();
    Object.keys(form).forEach((key) => {
      if (form[key] != '' && form[key] != null && form[key] != undefined) {
        const value = form[key];

        if (key == 'attachments' && form[key]?.length > 0) {
          for (let i = 0; i < value.length; i++) {
            Form.append(`attachment_ids[${i}]`, value[i]);
          }
        }

        if (key == 'tags' && Array.isArray(value)) {
          for (let i = 0; i < value.length; i++) {
            Form.append(`tags[${i}]`, value[i]);
          }
        }

        if (key == 'faqs' && Array.isArray(value)) {
          for (let i = 0; i < value.length; i++) {
            Form.append(`faqs[${i}][question]`, value[i].question);
            Form.append(`faqs[${i}][answer]`, value[i].answer);
          }
        }
        if (key == 'addons' && Array.isArray(value)) {
          for (let i = 0; i < value.length; i++) {
            if (value[i].title) {
              Form.append(`addons[${i}][title]`, value[i].title);
            }
            if (value[i].price) {
              Form.append(`addons[${i}][price]`, value[i].price);
            }
            if (value[i].description) {
              Form.append(`addons[${i}][description]`, value[i].description);
            }
            if (value[i].additional_time_unit && value[i].additional_time) {
              Form.append(`addons[${i}][additional_time_unit]`, value[i].additional_time_unit);
            }
            if (value[i].additional_time) {
              Form.append(`addons[${i}][additional_time]`, value[i].additional_time);
            }
          }
        }
        // if (key == 'addons' && Array.isArray(value)) {
        //   for (let i = 0; i < value.length; i++) {
        //     Form.append(` addons[${i}][question]`, value[i].question);
        //     Form.append(` addons[${i}][answer]`, value[i].answer);
        //   }
        // }

        if (
          key != 'attachments' &&
          key != 'tags' &&
          key != 'questions' &&
          key != 'faqs' &&
          key != 'addons'
        ) {
          Form.append(key, value);
        }
      }
    });
    return this.http.post(`${environment.endpoint}/freelancers/services`, Form);
  }

  getService(id: any) {
    return this.http.get(`${environment.endpoint}/freelancers/services/${id}`);
  }

  editService(form: any, id: any) {
    const Form = new FormData();

    Object.keys(form).forEach((key) => {
      const value = form[key];

      if (value === '' || value === null || value === undefined) return;

      if (key === 'cover_photo') {
        if (value instanceof File) {
          Form.append('cover_photo', value);
        }
        return;
      }

      if (key === 'attachments' && Array.isArray(value) && value.length) {
        value.forEach((item: any, i: number) => {
          Form.append(`attachment_ids[${i}]`, item);
        });
        return;
      }

      if (key === 'tags' && Array.isArray(value)) {
        value.forEach((item: any, i: number) => {
          Form.append(`tags[${i}]`, item);
        });
        return;
      }
      if (key === 'faqs' && Array.isArray(value)) {
        value.forEach((faq: any, i: number) => {
          Form.append(`faqs[${i}][question]`, faq.question);
          Form.append(`faqs[${i}][answer]`, faq.answer);
        });
        return;
      }
      if (key === 'addons' && Array.isArray(value)) {
        value.forEach((addon: any, i: number) => {
          if (addon.title) Form.append(`addons[${i}][title]`, addon.title);
          if (addon.price) Form.append(`addons[${i}][price]`, addon.price);
          if (addon.description) Form.append(`addons[${i}][description]`, addon.description);
          if (addon.additional_time_unit && addon.additional_time)
            Form.append(`addons[${i}][additional_time_unit]`, addon.additional_time_unit);
          if (addon.additional_time)
            Form.append(`addons[${i}][additional_time]`, addon.additional_time);
        });
        return;
      }
      Form.append(key, value);
    });

    return this.http.post(`${environment.endpoint}/freelancers/services/${id}`, Form);
  }

  deleteService(id: any) {
    return this.http.delete(`${environment.endpoint}/freelancers/services/${id}`);
  }
  // freelancers/services
  getServices(userName?: string, page: any = 1, per_page: number = 10, status: string = '') {
    return this.http.get(
      `${environment.endpoint}/profile/${userName}/services?page=${page}&per_page=${per_page}${
        status ? `&status=${status}` : '&status=approved'
      }`
    );
  }

  getServicesByUser(freelancerName: string) {
    return this.http.get(`${environment.endpoint}/profile/${freelancerName}/services`);
  }
  makeReport(id: any, form: any) {
    return this.http.post(`${environment.endpoint}/reports/${id}`, form);
  }

  // Following and Followers

  followUser(username: string) {
    return this.http.post(`${environment.endpoint}/follows/toggle/${username}`, {});
  }
  getFollowers(username: string, params: any) {
    return this.http.get(
      `${environment.endpoint}/profile/${username}/followers?page=${params.page}&per_page=${params.per_page}`
    );
  }
  getFollowing(username: string, params: any) {
    return this.http.get(
      `${environment.endpoint}/profile/${username}/following?page=${params.page}&per_page=${params.per_page}`
    );
  }

  // Stripe Account Status
  stripeAccoutStatus() {
    return this.http.get(`${environment.endpoint}/freelancers/stripe/status`);
  }
  // onboarding
  onBoarding() {
    return this.http.post(`${environment.endpoint}/freelancers/stripe/onboarding`, {});
  }
  clientCheckout(id: string) {
    return this.http.post(`${environment.endpoint}/clients/orders/${id}/checkout`, {});
  }
  transactions(page: number = 1, per_page: number = 10) {
    return this.http.get(`${environment.endpoint}/transactions?page=${page}&per_page=${per_page}`);
  }
  earnings() {
    return this.http.get(`${environment.endpoint}/freelancers/stripe/earnings`);
  }
}
